import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import cx from "classnames";
import Avatar, { AvatarProps } from "./Avatar";

export interface AvatarWithIconProps extends AvatarProps {
  /** The icon to display (FontAwesome IconProp) */
  icon: IconProp;
  /** Tailwind className for the icon colour and size */
  iconColourClassName?: string;
  /** Optional: className for the icon container */
  iconContainerClassName?: string;
  /** Optional: className for the avatar container */
  containerClassName?: string;
}

/**
 * Renders an Avatar with an icon overlayed or adjacent, all inside a span.
 * The icon is positioned absolutely at the top-right by default, but can be styled via className props.
 */
const AvatarWithIcon: React.FC<AvatarWithIconProps> = ({
  icon,
  iconColourClassName = "text-gray-500",
  iconContainerClassName = "absolute -top-1 -right-1 z-10",
  containerClassName = "relative inline-block align-middle",
  ...avatarProps
}) => {
  return (
    <span className={cx(containerClassName)}>
      {/* Avatar is rendered as usual */}
      <Avatar {...avatarProps} />
      {/* Icon overlays the avatar, positioned with Tailwind */}
      <span className={cx(iconContainerClassName)}>
        <FontAwesomeIcon icon={icon} className={iconColourClassName} />
      </span>
    </span>
  );
};

export default AvatarWithIcon;
